/** Бот поддержки в Telegram — туда же ведут экраны входа и блокировки. */
export const SUPPORT_BOT_URL = 'https://t.me/open_academy_support_bot'
